<style src="./Days.css"></style>
<template>
    <div class="epg__days-wrap">
        <div
                :class="[
                'epg__btn',
                'epg__btn--day',
                'epg__btn--left', {
                'epg__btn--disabled': daysWidth >= daysInnerWidth
                }]"
                v-on:click="previousDays()">
            <svg class="epg__chevron">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-left"></use>
            </svg>
        </div>
        <div
                :class="[
            'epg__btn',
            'epg__btn--day',
            'epg__btn--right', {
            'epg__btn--disabled': daysWidth >= daysInnerWidth
            }]"
                v-on:click="nextDays()">

            <svg class="epg__chevron">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-chevron-right"></use>
            </svg>
        </div>

        <div class="epg__btn epg__btn--now" v-on:click="now()">{{nowLabel}}</div>
        <div class="epg__days" ref="days">
            <div ref="daysInner" class="epg__days-inner" :style="`transform:translateX(-${daysTranslateProp}px)`">
                <div v-for="d in days" class="epg__day" v-on:click="selectDay(d.date)"
                     :class="[{'epg__day--selected': d.date.isSame(selectedDate, 'day')}]">
                    {{d.label}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import moment from 'moment'
  import MomentIterator from 'moment-iterator'

  export default {
    name: 'epg-days',
    props: ['nowLabel', 'todayLabel', 'selectedDate'],
    data () {
      return {
        daysWidth: 0,
        daysInnerWidth: 0,
        daysTranslateProp: 0,
        daysPositions: [],
        days: []
      }
    },
    mounted () {
      setTimeout(() => this.recalculate(this.todayLabel), 400)
    },
    methods: {
      _setDaysPositions () {
        const self = this
        let width = 0
        this.daysWidth = this.$refs.days.offsetWidth
        this.daysPositions = []
        this.daysPositions.push({
          index: 0,
          position: 0,
          width: 0
        })

        let daysElements = document.getElementsByClassName('epg__day')

        Array.from(daysElements).forEach(
          function (element, index, array) {
            let style = element.currentStyle || window.getComputedStyle(element)
            width += element.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
            self.daysPositions.push({
              index: index + 1,
              position: width,
              width: element.offsetWidth
            })
          }
        )

        this.daysInnerWidth = self.daysPositions[self.daysPositions.length - 1].position
      },
        /*
         * Center the selected day
         */
      centerOnSelectedDay () {
        let centerPos = 0
        this._setDaysPositions()

        if (this.daysWidth <= this.daysInnerWidth) {
          for (let i = 0; i < this.daysPositions.length - 1; i++) {
            if (this.days[i] && this.days[i].date.isValid() && this.selectedDate.isSame(this.days[i].date, 'day')) {
              centerPos = (this.daysPositions[i].position + this.daysPositions[i].width / 2) - parseInt(this.daysWidth / 2)
              if (centerPos > 0 && centerPos < (this.daysInnerWidth - this.daysWidth)) {
                this.daysTranslateProp = centerPos
              } else if (centerPos < 0) {
                this.daysTranslateProp = 0
              } else {
                this.daysTranslateProp = (this.daysInnerWidth - this.daysWidth + 20)
              }
            }
          }
        } else {
          this.daysTranslateProp = 0
        }
      },
        /*
         * Go to current time and center-align it
         */
      now () {
        this.$emit('epgNow')
      },
        /*
         * Show the next part of days
         */
      nextDays () {
        if ((this.daysTranslateProp + this.daysWidth) < this.daysInnerWidth && (this.daysTranslateProp + this.daysWidth) < (this.daysInnerWidth - this.daysWidth + 20)) {
          this.daysTranslateProp += (this.daysWidth - 20)
        } else {
          this.daysTranslateProp = (this.daysInnerWidth - this.daysWidth + 20)
        }
      },
        /*
         * Show the previous part of days
         */
      previousDays () {
        if ((this.daysTranslateProp - this.daysWidth) > 0) {
          this.daysTranslateProp -= this.daysWidth
          // this.daysTranslateProp = this.daysPositions[newSelectedIndex]
        } else {
          this.daysTranslateProp = 0
        }
      },
      setUpDays (todayLabel) {
        this.days = []

        this.days.push({
          label: todayLabel,
          date: moment()
        })

        MomentIterator(moment().add(1, 'days'), moment().add(15, 'days')).each('1 day', (d) => {
          this.days.push({
            label: d.format('ddd D MMM'),
            date: d
          })
        })
      },
      /*
       * Select day handler
       */
      selectDay (date) {
        this.$emit('epgSelectDay', date)
      },
      /*
       * Recalculate dimensions
       */
      recalculate (todayLabel) {
        this.setUpDays(todayLabel)
        this.daysWidth = this.$refs.days.offsetWidth
        this.centerOnSelectedDay()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Days.vue?6051c5d0